// extracted by mini-css-extract-plugin
export default {"root":"styles_root__rjbtT","dragging-over":"styles_dragging-over__odhvd","draggingOver":"styles_dragging-over__odhvd","color":"styles_color__i9B+h"};